import { Component, inject, input } from '@angular/core';
import { ConfirmationType } from './button.types';
import { Button } from '@openng/optimus-ui/button';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { Confirmation, PrimeTemplate } from '@openng/optimus-ui/api';
import {
    ConfirmationWrapperService,
    DEFAULT_CONFIRMATION_QUESTION_INPUT,
} from '../../../services/wrappers/confirmation-wrapper.service';
import { ConfirmPopupModule } from '@openng/optimus-ui/confirmpopup';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { SaveButtonComponent } from './save-button.component';

@Component({
    selector: 'app-confirm-button',
    templateUrl: 'button.component.html',
    imports: [Button, TranslatePipe, SvgIconComponent, PrimeTemplate, ConfirmPopupModule, ConfirmDialogModule],
})
export class ConfirmButtonComponent extends SaveButtonComponent {
    private readonly confirmationService = inject(ConfirmationWrapperService);

    confirmationType = input<ConfirmationType>('popup');
    confirmationMessageConfig = input<Confirmation>(DEFAULT_CONFIRMATION_QUESTION_INPUT);

    override async onClick(event: Event) {
        switch (this.confirmationType()) {
            case 'popup':
                if (await this.confirmationService.question(event.target as EventTarget, 'confirmPopup', this.confirmationMessageConfig())) {
                    this.clickEvent.emit(event);
                }
                break;
            case 'dialog':
                if (await this.confirmationService.question(event.target as EventTarget, 'confirmDialog', this.confirmationMessageConfig())) {
                    this.clickEvent.emit(event);
                }
                break;
            default:
                this.clickEvent.emit(event);
        }
    }

}
